import React, { ReactNode, CSSProperties } from 'react';
import './styles.scss';

interface OrganisationCardProps {
  title: string;
  description: string;
  children: ReactNode;
  contentStyle?: CSSProperties;
}

export const OrganisationCard: React.FC<OrganisationCardProps> = ({
  title,
  description,
  children,
  contentStyle,
}) => {
  return (
    <div className="organisation-card">
      <div className="organisation-card__body">
        <div className="organisation-card__left">
          <div className="organisation-card__title">
            {title}
          </div>
          <div className="organisation-card__description">
            {description}
          </div>
        </div>
        <div className="organisation-card__right">
          <div
            className="organisation-card__right-content"
            style={contentStyle}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganisationCard;
